<div class="container">
  <div class="row">
    <div class="col-12">
      <iframe width="1200" height="800" src="/Content/terms.htm"></iframe>
      <form>
        <div class="form-group no-left-padding">
          <input type="checkbox" name="isAccepted" [(ngModel)] ="isAccepted" id="isAccepted" class="icheckbox_square-blue" unchecked>
          <label class="icheck-label form-label" for="isAccepted">Agree?</label>
        </div>
        <input type="submit" value="Submit" (click)="submit()" [disabled]="isSubmitDisabled()" class="btn btn-primary" />
      </form>
    </div>
  </div>
</div>
